import { createAllegatoModel } from "../allegatoModel";
import { createCriteriInvioModel } from "../criteriInvioModel";
import { createDocumentoModel } from "../documentoModel";
import { createOffertaModel, createOffertaVoceModel } from "../offertaModel";
import { createPagamentoModel } from "../pagamentoModel";
import { createProdottoRichiestoModel } from "../prodottoRichiestoModel";
import { createRichiestaModel } from "../richiestaModel";
import { createServizioRichiestoModel } from "../servizioRichiestoModel";
import { createTrackingStepModel } from "../trackingModel";

const mapProdotto = (item = {}) => createProdottoRichiestoModel(item);
const mapServizio = (item = null) => (item ? createServizioRichiestoModel(item) : null);
const mapAllegato = (item = {}) => createAllegatoModel(item);
const mapOffertaVoce = (item = {}) => createOffertaVoceModel(item);
const mapOfferta = (item = {}) =>
  createOffertaModel({
    ...item,
    voci: Array.isArray(item.voci) ? item.voci.map(mapOffertaVoce) : [],
  });
const mapTracking = (item = {}) => createTrackingStepModel(item);
const mapDocumento = (item = {}) => createDocumentoModel(item);

/**
 * Normalizza un payload REST/DTO in entity Richiesta usabile dall'app.
 */
export const toRichiestaEntity = (dto = {}) => ({
  ...createRichiestaModel(dto),
  criteriInvio: createCriteriInvioModel(dto.criteriInvio || {}),
  prodotti: Array.isArray(dto.prodotti) ? dto.prodotti.map(mapProdotto) : [],
  servizio: mapServizio(dto.servizio),
  allegati: Array.isArray(dto.allegati) ? dto.allegati.map(mapAllegato) : [],
  offerte: Array.isArray(dto.offerte) ? dto.offerte.map(mapOfferta) : [],
  pagamento: createPagamentoModel(dto.pagamento || {}),
  tracking: Array.isArray(dto.tracking) ? dto.tracking.map(mapTracking) : [],
  documenti: Array.isArray(dto.documenti) ? dto.documenti.map(mapDocumento) : [],
});

/**
 * Serializza entity Richiesta in DTO verso backend.
 * Attualmente 1:1, lasciato esplicito per evoluzioni future.
 */
export const toRichiestaDto = (entity = {}) => ({
  ...entity,
  criteriInvio: { ...(entity.criteriInvio || {}) },
  prodotti: Array.isArray(entity.prodotti) ? entity.prodotti.map((x) => ({ ...x })) : [],
  servizio: entity.servizio ? { ...entity.servizio } : null,
  allegati: Array.isArray(entity.allegati) ? entity.allegati.map((x) => ({ ...x })) : [],
  offerte: Array.isArray(entity.offerte)
    ? entity.offerte.map((offerta) => ({
        ...offerta,
        voci: Array.isArray(offerta.voci) ? offerta.voci.map((voce) => ({ ...voce })) : [],
      }))
    : [],
  pagamento: { ...(entity.pagamento || {}) },
  tracking: Array.isArray(entity.tracking) ? entity.tracking.map((x) => ({ ...x })) : [],
  documenti: Array.isArray(entity.documenti) ? entity.documenti.map((x) => ({ ...x })) : [],
});

export const toRichiestaEntityList = (items = []) => items.map(toRichiestaEntity);
export const toRichiestaDtoList = (items = []) => items.map(toRichiestaDto);

